import { useParams } from 'react-router-dom';

import { LoadingSpinner } from '../../../../components';
import { useGetExamEventSettings } from '../../../../hooks';

import ExamCompletedCard from './exam-completed-card';
import ExamResult from './exam-result';

function ExamCompletedSection() {
  const { examCardId } = useParams();

  const { isLoading, settings } = useGetExamEventSettings({ cardId: examCardId as string });

  if (isLoading)
    return (
      <div className='grid h-dvh w-screen place-items-center'>
        <LoadingSpinner />
      </div>
    );

  const examResultSettings = settings.result;

  if (examResultSettings.display) {
    return <ExamResult />;
  }

  return <ExamCompletedCard />;
}

export default ExamCompletedSection;
